module.exports = __webpack_public_path__ + "assets/img/lecturer-no-avatar--small.svg";